export const Laptop = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="5" y="8" width="22" height="16" rx="1" stroke="currentColor" stroke-width="2"/>
<path d="M2 28H30" stroke="currentColor" stroke-width="2"/>
</svg>`;
